import React from "react";
import { Box, Heading, VStack, Text} from "@chakra-ui/react";
import AppointmentsDataTable from "./AppointmentsDataTable";
import { useQuery } from "@tanstack/react-query";
import { queryKeys, queryFns } from "repo/sessions";
import { add } from "date-fns";

const SameDaySessions: React.FC = () => {
  const today = new Date();
  today.setHours(0);
  today.setMinutes(0);
  today.setSeconds(0);
  today.setMilliseconds(0);

  const defaultDateFilter: any = {
    id: 'start_time_range',
    value: JSON.stringify([today, add(today, { days: 1})])
  };

  const dataDefaults= {
    pageSize: 4,
    defaultFilters: [defaultDateFilter],
    order: ["start_time", "ASC"]
  };

  const dataKey = queryKeys.data(true, dataDefaults);

  // Our QueryKey should be the same as the initial query
  // of AppointmentsDataTable->LazyDataTable down below
  const { isLoading, error, data } = useQuery({
    queryKey: dataKey({}),
    queryFn: queryFns.data
  });
  return (
    <Box>
      <Heading size="lg" mb={8}>
        My Appointments
      </Heading>
      <VStack spacing={8} alignItems="flex-start">
        {data?.entries?.length == 0 ? (
          <>
            <Heading size="md" mb={8}>
              You&apos;re all caught up!
            </Heading>
          </>
        ) : ( (isLoading || error) ?
          <Text> Loading... </Text>
          :
          <>
            <AppointmentsDataTable dataKey={dataKey}/>
          </>
        )}
      </VStack>
    </Box>
  );
}

export default SameDaySessions;
